import { NewTabLink } from '../Link';

export function DocsInContext() {
  return (
    <NewTabLink href="https://tolgee.io/js-sdk/in-context">
      Learn more in Docs
    </NewTabLink>
  );
}
